import { resetPasswordTokenStatus } from 'src/graphql/queries/resetPasswordToken.graphql';
import type {
  IResetPasswordTokenStatusQuery,
  IResetPasswordTokenStatusQueryVariables,
} from 'src/graphql/queries/resetPasswordToken.graphql.types';
import { useQuery } from 'urql';
import useAuth from '../auths/useAuth';

const useResetPasswordTokenStatus = () => {
  const { resetPasswordToken } = useAuth();
  const [{ data, fetching }] = useQuery<
    IResetPasswordTokenStatusQuery,
    IResetPasswordTokenStatusQueryVariables
  >({
    query: resetPasswordTokenStatus,
    variables: { token: resetPasswordToken! },
    requestPolicy: 'network-only',
    pause: !resetPasswordToken,
  });

  return { fetching, isTokenValid: data?.resetPasswordTokenStatus };
};

export default useResetPasswordTokenStatus;
